<ng-container *transloco="let t">
<ion-header>
	<ion-toolbar>
		@if (!['landing', 'login', 'register'].includes(title())) {
			<ion-buttons slot="start">
				@if (title() !== 'home') {
					<ion-back-button [defaultHref]="backHref() ?? translateService.localize('/landing')" text=""></ion-back-button>
				}
			</ion-buttons>
		}
		@if (title() !== 'landing') {
			<ion-title class="toolbar-text" slot="start">
				<ion-icon class="toolbar-icon" name="{{icon()}}" aria-hidden="true"></ion-icon>
				<span class="toolbar-title-text">
					@if (translateTitle()) {
						{{t('page.label.' + title())}}
					} @else {
						{{ title() }}
					}
				</span>
			</ion-title>
		}
		@if (title() === 'landing') {
			<ion-buttons slot="end" class="landing-auth-buttons">
				<ion-button [routerLink]="translateService.localize('/register')" class="landing-register-button" color="danger"
				            fill="outline" id="register" replaceUrl="true" shape="round">
					{{t('landing.button_register')}}
				</ion-button>
				<ion-button [routerLink]="translateService.localize('/login')" class="landing-login-button" color="danger"
				            fill="solid"
				            id="login" replaceUrl="true" shape="round">
					{{t('landing.button_login')}}
				</ion-button>
			</ion-buttons>
		}
		<ion-buttons slot="end" class="lang-select-buttons">
			<app-language-button></app-language-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>

</ng-container>
